import styled from 'styled-components';
import { themeGet } from '../../theme/utils';

import { InputBase } from './InputBase';

export const Input = styled(InputBase)`
  width: 100%;
  height: 44px;
  border-radius: 6px;
  border: 2px solid ${themeGet.colors('swirl')};
  font-size: ${themeGet.fontSize(6)};
  text-indent: ${themeGet.space(2)};

  &::-webkit-search-cancel-button,
  &::-webkit-search-decoration {
    appearance: none;
  }

  &::placeholder {
    color: ${themeGet.colors('swirl')};
  }
`;
